<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 18 18" enable-background="new 0 0 18 18"
  xml:space="preserve">
  <polygon fill="currentColor" points="9 9.9 16.9 3 1.1 3 " />
  <polygon fill="currentColor" points="13.2 8.6 17 12.5 17 5.3 " />
  <polygon fill="currentColor" points="4.8 8.5 1 5.3 1 12.4 " />
  <polygon fill="currentColor" points="11.9 9.7 9 12.2 6.1 9.7 1 14.9 1 15 17 15 " />
</svg>